'use client';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { useCurrentLocale } from '@peerless/ui-locale';
import { useDebouncedCallback } from 'use-debounce';
import { compatibilitySearch } from '@peerless/data-access/next-api';
import { debounceTime, noResults } from './types';

export function useCompatibilitySearch(sku: string) {
  const { locale } = useCurrentLocale();
  const [keyword, setKeyword] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['Compatibility', 'Search', locale, keyword],
    queryFn: context =>
      compatibilitySearch(
        { locale, keyword, product: sku },
        {
          signal: context.signal,
        }
      ),
    enabled: !!keyword,
  });

  const search = useDebouncedCallback((keyword: string) => {
    setKeyword(keyword);
  }, debounceTime);

  const reset = useCallback(() => {
    setKeyword('');
  }, [setKeyword]);

  return {
    data: data ?? noResults(keyword),
    isLoading,
    search,
    reset,
  };
}
